<template>
    <FAQComponent
        v-if="templateData"
        :templateData="templateData"
    />
</template>

<script>
import FAQComponent from '@vueapp/components/FAQComponent.vue'
export default {
    name: 'FAQ',
    components: {
        FAQComponent
    },
    data() {
        return {
            templateData: null
        }
    },
    props: {
        postSlug: String,
        postId: String
    },

    async beforeCreate() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        if(!this.postSlug && !this.postId) return;

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        const res = await fetch( BRYTER.homeUrl + '/faq/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                this.templateData = data;
            })
            .catch(error => {
                console.error('Error fetching FAQ data:', error);
            });
    }
}


</script>